import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-32 text-center">
      <div className="eyebrow text-tito-gold">404</div>
      <h1 className="mt-3 font-display font-bold text-4xl sm:text-5xl text-slate-900">Page not found.</h1>
      <p className="mt-4 text-slate-600">The page you are looking for has moved or no longer exists.</p>
      <Link to="/" className="inline-block mt-8">
        <Button className="rounded-sm bg-tito-blue hover:bg-blue-900 text-white">Back to home</Button>
      </Link>
    </div>
  );
}
